import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { EndpointParams, OrderCreate } from '@models/index';
import { HttpService } from '@services/index';

@Injectable()
export class OrderService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'payments', version: 1 };

    create(orderCreate: OrderCreate): Observable<any> {
        return this.post('orders/member', this.defaultEndpointParams, orderCreate);
    }
}
